import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import MemberLayout from '../../components/MemberLayout';
import { Field, Spinner } from '../../components/ui';
import api, { errMsg } from '../../services/api';
import { useMember } from '../../context/AuthContext';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { signIn } = useMember();
  const [pw, setPw] = useState({ password: '', confirm: '' });
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault();
    if (pw.password !== pw.confirm) return toast.error('Passwords do not match');
    setBusy(true);
    try {
      const { data } = await api.post('/public/reset-password', { token: params.get('token'), password: pw.password });
      signIn(data.token, data.member);
      toast.success('Password updated');
      navigate('/profile');
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <MemberLayout narrow>
      <div className="card p-7">
        <h1 className="font-display text-3xl font-bold text-navy-900">Choose a new password</h1>
        <form onSubmit={submit} className="mt-5 space-y-4">
          <Field label="New password" hint="At least 8 characters">
            <input type="password" className="input" required minLength={8} value={pw.password} onChange={e => setPw(p => ({ ...p, password: e.target.value }))} autoComplete="new-password" />
          </Field>
          <Field label="Confirm new password">
            <input type="password" className="input" required value={pw.confirm} onChange={e => setPw(p => ({ ...p, confirm: e.target.value }))} autoComplete="new-password" />
          </Field>
          <button disabled={busy} className="btn-primary w-full py-2.5">{busy && <Spinner size={16} />}Save password</button>
        </form>
      </div>
    </MemberLayout>
  );
}
